import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useCommonFragments from '../../../../../../base/hooks/CommonFragments';
import useOrderFragment from '../../../../../../wedding-wardrobe/src/components/orders/hooks/useOrderFragment';
import useClientsEventBookingGql from '../../../../../appointment-booking/src/components/appointments/hooks/useClientsEventBookingGql';

export default () => {
  const { gql, useQuery } = useAppContext();
  const { PhoneNumberFragment, AddressFragment, MeasurementFragment } = useCommonFragments();
  const { OrderFragment } = useOrderFragment();
  const { AppointmentBookingFragment } = useClientsEventBookingGql();

  const EventProfileFragment = gql`
fragment EventProfileFragment on Event {
  id
  gid
  budget
  status
  eventTitle
  eventPlanner
  department
  assignedPerson
  eventDate
  orderDeadline
  eventType
  guestsInvited
  guestsAcceptedInvite
  currentUserAccepted
  isEventOwner
}  
  `;

  const ClientProfileFragment = gql`
fragment ClientProfileFragment on Client {
  email
  firstName
  lastName
  isInvited
  dressSize
  events{
    ...EventProfileFragment
  }
  address {
    ...AddressFragment
  }
  appointments {
    ...AppointmentBookingFragment
  } 
  profileOrders {
    ...OrderFragment
  }
  bestPhoneNumber {
    id
    ...PhoneNumberFragment
  }
  measurement {
    ...MeasurementFragment
  }
}
${AddressFragment}
${PhoneNumberFragment}
${EventProfileFragment}
${OrderFragment}
${AppointmentBookingFragment}
${MeasurementFragment}
  `;

  const ClientProfilNodeQuery = gql`
  query profile {
    profile {
      id
      gid
      ...ClientProfileFragment
    }
  }  
  ${ClientProfileFragment}
  `;

  const useClientProfileNodeQuery = () => useQuery(ClientProfilNodeQuery, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  return {
    useClientProfileNodeQuery,
  };
};
